<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：会员-用户列表-会员等级
  -->
  <div>
  <el-dialog title="添加区域代理" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="选择用户" :label-width="formLabelWidth" prop="user_id" :rules="[{required: true,message: '请选择用户'}]">
        <el-row>
          <el-button @click="openUserDialog" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user.avatarUrl" width="100" height="100" />
            <span>ID:{{user.user_id}}</span><br>
            <span>昵称:{{user.nickName}}</span>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="代理级别" :label-width="formLabelWidth" prop="level" :rules="[{required: true,message: '请选择代理级别'}]">
        <div>
          <el-radio v-model="form.level" label="1" >省代</el-radio>
          <el-radio v-model="form.level" label="2">市代</el-radio>
          <el-radio v-model="form.level" label="3">区代</el-radio>
          <!-- <el-radio v-model="form.level" label="4">街道</el-radio> -->
        </div>
      </el-form-item>
      <el-form-item label="代理区域" :label-width="formLabelWidth" v-if="form.level>0" prop="city_id" >
        <el-select v-model="form.province_id" placeholder="省" @change="initCity" v-if="form.level>0">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
        </el-select>
        <el-select v-if="form.province_id!='' && form.level>1" v-model="form.city_id" placeholder="市" @change="initRegion" >
          <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[form.province_id]['city']"
            :key='index1'></el-option>
        </el-select>
        <el-select v-if="form.city_id!='' && form.level>2" v-model="form.region_id" placeholder="区" @change="initStreet" >
          <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[form.province_id]['city'][form.city_id]['region']"
            :key='index2'></el-option>
        </el-select>
        <!-- <el-select v-if="form.region_id!='' && form.level>3" clearable v-model="form.street_id" placeholder="街道/镇/乡" >
          <el-option :label="item3.name" :value="item3.id" v-for="(item3,index3) in areaList[form.province_id]['city'][form.city_id]['region'][form.region_id]['street']"
            :key='index3'></el-option>
        </el-select> -->

      </el-form-item>

      <el-form-item label="后台账号" :label-width="formLabelWidth" prop="admin_username" :rules="[{required: true,message: '后台账号不能为空'}]">
        <el-input v-model="form.admin_username" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="后台密码" :label-width="formLabelWidth" prop="admin_password" :rules="[{required: true,message: '后台密码不能为空'}]">
        <el-input v-model="form.admin_password" autocomplete="off" type="password" placeholder="不输入则不修改密码"></el-input>
      </el-form-item>
      <el-form-item label="到期时间" :label-width="formLabelWidth">
        <el-date-picker v-model="form.admin_expire_date_text" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" align="right" :picker-options="timePickerOpt"></el-date-picker>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addtUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--用户选择-->
  <GetUser :is_open="open_user"  :multi="false" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>
  import RegionagentApi from '@/api/regionagent.js';
  import select_district from '@/utils/select.district.js';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      GetUser
    },
    data() {
      return {
        /*省市区*/
        areaList: select_district,
        open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        user:{},
        form: {
          user_id: '',
          level:'1',
          province_id: '',
          city_id: '',
          region_id: '',
          street_id: '',
          admin_username: '',
          admin_password: '',
          admin_expire_date_text: '',
        },
        // 会员到期时间选择器左侧快捷选项
        timePickerOpt: {
          shortcuts: [{
            text: '一年',
            onClick(picker) {
              const date = new Date()
              date.setFullYear(date.getFullYear() + 1)
              picker.$emit('pick', date)
            }
          }, {
            text: '两年',
            onClick(picker) {
              const date = new Date()
              date.setFullYear(date.getFullYear() + 2)
              picker.$emit('pick', date)
            }
          }, {
            text: '三年',
            onClick(picker) {
              const date = new Date()
              date.setFullYear(date.getFullYear() + 3)
              picker.$emit('pick', date)
            }
          }]
        },
      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*初始化城市id*/
      initCity() {
        this.form.city_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.form.region_id = ''
      },
      /*初始化街道id*/
      initStreet() {
        this.form.street_id = ''
      },
      /*修改用户*/
      addtUser() {
        let self = this;

        let params = self.form;
        console.log(params)
        if(!params.user_id){
            this.showMessage('请选择用户');
            return ;
        }
        if(!params.level){
            this.showMessage('请选择代理级别');
            return ;
        }
        if(!params.province_id){
          this.showMessage('请选择代理区域');
          return ;
        }
        self.loading = true;
        RegionagentApi.regionagentAdd(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params;
        console.log(e.params)
        this.form.user_id = e.params.user_id;
      }
      this.open_user = false;
    },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/regionagent/regionagent/dialog/Add.vue